import { styled, Typography } from "@mui/material";
import { ClipboardCopy } from "@volt_developers/components";

import { useTranslateCountryCode } from "hooks/useTranslateCountryCode";

import { CountryFlagIcon } from "../CountryFlag";

import type { CountryCode } from "models/CountryCode";

interface FlagWithClipboardCountryProps {
  countryCode: CountryCode;
}

export function FlagWithClipboardCountry({
  countryCode,
}: FlagWithClipboardCountryProps) {
  const { t: tCountryCode } = useTranslateCountryCode();

  return (
    <CountryWithLabelWrapper>
      <CountryFlagIcon code={countryCode} size={20} />
      <ClipboardCopy>
        <Typography variant="small">{tCountryCode(countryCode)}</Typography>
      </ClipboardCopy>
    </CountryWithLabelWrapper>
  );
}

const CountryWithLabelWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  gap: theme.spacing(1),
}));
